import { render, staticRenderFns } from "./MobileNews.vue?vue&type=template&id=e852d2d6&scoped=true&"
import script from "./MobileNews.vue?vue&type=script&lang=js&"
export * from "./MobileNews.vue?vue&type=script&lang=js&"
import style0 from "./MobileNews.vue?vue&type=style&index=0&id=e852d2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e852d2d6",
  null
  
)

export default component.exports